export default {
  currentUser: null,
  userEmail: null,
  permissions: [],
  token: null,
  authenticated: false,
};
